import { useEffect } from 'react'

import { MealTimeline } from '../views/meals/MealTimeline'

// Timeline entries arrive from the Apollo cache with a __typename on
// each element; the editor manages clean objects, so strip it both
// when seeding and (belt-and-braces) in mutationConvert.
const sanitize = timeline =>
  (timeline || []).map(({ __typename, ...entry }) => entry)

export const TimelineField = ({
  value,
  onChange,
  defaultValue,
  autoformProps
}) => {
  // Same pattern as AmountRangeField: the doc can arrive renders after
  // mount (CrudView edit flow), when the form hook froze its defaults.
  useEffect(() => {
    if (value === undefined && defaultValue !== undefined)
      onChange(defaultValue)
  }, [value, defaultValue])

  const useValue = value === undefined ? defaultValue : value
  const timeline = sanitize(useValue)

  const initialValues = (autoformProps && autoformProps.initialValues) || {}
  const ingredients = (initialValues.ingredientList || [])
    .filter(entry => entry.ref && entry.ref.id)
    .map(entry => ({
      id: String(entry.ref.id),
      name: entry.ref.search || ''
    }))

  return (
    <MealTimeline
      timeline={timeline}
      ingredients={ingredients}
      onChange={onChange}
    />
  )
}
